/**
 * Resolve a URL de um asset servido pela API.
 *
 * A API retorna ícones/arquivos locais como caminho relativo
 * (ex.: "aplicativos/x.png"), que são prefixados com API_PUBLIC_URL.
 * URLs absolutas (ex.: S3) são retornadas sem alteração.
 */
export const resolveAssetUrl = (path?: string | null): string => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  const base = useRuntimeConfig().public.API_PUBLIC_URL;
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
};
